var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContentCopyFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1585 0.5H1.73749C0.965563 0.5 0.333984 1.11364 0.333984 1.86364V11.4091H1.73749V1.86364H10.1585V0.5ZM12.2638 3.22725H4.54451C3.77258 3.22725 3.141 3.84089 3.141 4.59089V14.1363C3.141 14.8863 3.77258 15.5 4.54451 15.5H12.2638C13.0357 15.5 13.6673 14.8863 13.6673 14.1363V4.59089C13.6673 3.84089 13.0357 3.22725 12.2638 3.22725Z",
    fill: "#007AFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentCopyFilled);
export default __webpack_public_path__ + "static/media/content_copy_filled.6479aa15.svg";
export { ForwardRef as ReactComponent };